import * as React from "react";
import type { SVGProps } from "react";
const CosmeticsStore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4362_8037)">
      <path
        fill="currentColor"
        d="M17.0169 23.1859v-8.2716c0-.4491-.3058-.8135-.6833-.8135h-.0287V7.0234h-.7027c.002-1.1692.0108-2.143.0174-2.9496.0251-2.8658.0307-3.5468-.3134-3.8942-.1174-.1184-.2693-.1806-.4393-.1806-.2288 0-.4508.1134-.7324.257-.2479.127-.5571.2849-.9449.4052-2.5119.7801-2.8104 2.8914-2.8219 2.981l-.0028 3.3812h-.6764v7.0773H9.66c-.3776 0-.6834.3644-.6834.8136v8.2711c0 .4497.3058.8136.6834.8136h6.6736c.3775.0005.6833-.3639.6833-.8131m-1.5256-9.0852h-4.9894V7.9118l4.9894.0572z"
      />
    </g>
    <defs>
      <clipPath id="clip0_4362_8037">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default CosmeticsStore;
